const styles = (theme) => ({
	container: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		gap: 1,
		padding: "16px",
	},
	cabecalho: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexWrap: "wrap",
		gap: 1,
	},
	botaoAtualizar: {
		minWidth: "160px",
	},
	contentContainer: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
	},
});

export default styles;
